export default {
    props: {
        date: {
            type: Date,
            default: undefined,
            kComposite: 'date'
        }, 
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        }, 
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }, 
        type: {
            type: String,
            default: undefined,
            kComposite: 'type'
        }, 
        selected: {
            type: Boolean,
            default: undefined,
            kComposite: 'selected'
        }, 
        slotSize: {
            type: [Number, String],
            default: undefined,
            kComposite: 'slotSize'
        }, 
        timeHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'timeHeaderTemplate'
        }, 
        dayHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'dayHeaderTemplate'
        }, 
        weekHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'weekHeaderTemplate'
        }, 
        monthHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'monthHeaderTemplate'
        }, 
        yearHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'yearHeaderTemplate'
        }, 
        resizeTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'resizeTooltipFormat'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttView/Views.js